import { openInNewTab } from '@strata/helper-functions';
import { IconDropdownMenu } from '@strata/react-dropdown-menu';
import { useNavigate } from 'react-router';

import { getIntakeSourceFile } from 'api/intakeCaseAPI';
import { handleError } from 'services/Error';
import { AppRoutes } from 'services/routes';
import { type IntakeSourceSummary } from 'store/api/intakeCaseApi';

interface ArchivedIntakeSourceActionsMenuProps {
    intakeSourceId: string;
    intakeSource: IntakeSourceSummary;
}

export const ArchivedIntakeSourceActionsMenu = ({
    intakeSourceId,
    intakeSource,
}: ArchivedIntakeSourceActionsMenuProps) => {
    const navigate = useNavigate();

    return (
        <IconDropdownMenu
            menuItems={[
                {
                    text: 'View',
                    onItemClick: () => {
                        void (async () => {
                            try {
                                openInNewTab(
                                    URL.createObjectURL(
                                        await getIntakeSourceFile({ intakeSourceId }),
                                    ),
                                );
                            } catch (err) {
                                handleError('Error downloading file.', err as Error);
                            }
                        })();
                    },
                },
                ...(intakeSource?.intake_case_id
                    ? [
                          {
                              text: 'View Intake Case',
                              onItemClick: () =>
                                  navigate(
                                      AppRoutes.intakeCaseDetails(intakeSource?.intake_case_id),
                                  ),
                          },
                      ]
                    : []),
            ]}
        />
    );
};
